import { defineComponent } from "vue";
export default defineComponent({
  name: "TrendSlider",
  props: {
    positionByNumber: {
      type: Number,
      default: 2
    },
    containerClass: {
      type: String,
      default: ""
    }
  },
  emits: ["emit-last-position-value"],
  watch: {
    positionByNumber() {
      this.convertPositionToClass(this.positionByNumber);
    }
  },
  /**
   * min position: 0 - 10% / max position: 8 - 90%; Base on current trendSlider.scss
   * for number difference passed as a prop remember to transform it in a 0-5 scale.
   * :position-by-number="number * x || number / y || "
   */
  mounted() {
    this.convertPositionToClass(this.positionByNumber);
  },
  beforeUnmount() {
    this.$emit("emit-last-position-value", this.positionByNumber);
  },
  methods: {
    convertPositionToClass(positionNumber) {
      var _a, _b, _c, _d, _e, _f;
      var targetTrendBar = document.getElementById("target-trendbar");
      switch (positionNumber) {
        case 0:
          targetTrendBar.className = "";
          (_a = targetTrendBar.classList) === null || _a === void 0 ? void 0 : _a.add("zero");
          break;
        case 1:
          targetTrendBar.className = "";
          (_b = targetTrendBar.classList) === null || _b === void 0 ? void 0 : _b.add("quarter");
          break;
        case 2:
          targetTrendBar.className = "";
          (_c = targetTrendBar.classList) === null || _c === void 0 ? void 0 : _c.add("one-half");
          break;
        case 3:
          targetTrendBar.className = "";
          (_d = targetTrendBar.classList) === null || _d === void 0 ? void 0 : _d.add("three-fourths");
          break;
        case 4:
          targetTrendBar.className = "";
          (_e = targetTrendBar.classList) === null || _e === void 0 ? void 0 : _e.add("hundred");
          break;
        default:
          targetTrendBar.className = "";
          (_f = targetTrendBar.classList) === null || _f === void 0 ? void 0 : _f.add("one-half");
      }
    }
  }
});